import { Injectable } from '@angular/core';
import { HttpService, VersionedData } from '@symphony-solo/shared/http/src';
import { Observable } from 'rxjs';
import { TaxrateDto } from '../dtos';

@Injectable()
export class TaxrateService {
  private path = 'versionedupdate/taxrates';
  constructor(private httpService: HttpService) {}

  public getTaxrates(versionHash: string): Observable<VersionedData<TaxrateDto[]>> {
    return this.httpService.makeGet(`${this.path}/${versionHash}`);
  }
}
